import Badge from './Badge.vue'

import type { StatusType } from '@/components/TaskSlider'

export interface Props {
  status: StatusType
}

export default Badge